import { Tr, Td, HStack, VStack, Box, Stack, Button, Image, Icon } from '@chakra-ui/react';
import { Fragment } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useGetImageUrl } from 'src/hooks';
import { Carrier } from 'src/utils/__generated__/graphql';

export const CarrierListItem = ({ carrier }: { carrier: Carrier }) => {
  const { imageUrl: logoUrl } = useGetImageUrl(carrier?.image ?? '');

  return (
    <Fragment>
      <Tr _hover={{ bg: 'gray.50' }}>
        <Td display={{ base: 'none', md: 'table-cell' }}>
          <HStack>
            <Image src={logoUrl || '/assets/img/logo-placeholder.jpg'} alt={carrier.name} boxSize="80px" />
          </HStack>
        </Td>
        <Td>
          <VStack align="start" spacing={0} pl={{ base: 2, md: 0 }}>
            <Box fontWeight="bold" fontSize="lg">
              {carrier.name}
            </Box>
            <Box fontWeight="medium" fontSize="sm" color={'gray.500'}>
              {carrier.address}
            </Box>
          </VStack>
        </Td>
        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {carrier.phone}
        </Td>

        <Td display={{ base: 'none', md: 'table-cell' }} fontSize="sm">
          {carrier.isOnline ? (
            <Icon as={FaCheckCircle as any} color="teal" size={16} />
          ) : (
            <Icon as={FaTimesCircle as any} color="gray" size={16} />
          )}
        </Td>

        <Td>
          <Stack direction={{ base: 'column', md: 'row' }} fontSize={{ base: 'sm', md: 'md' }} alignItems="center">
            {[{ label: 'Edit', url: `edit/${carrier.id}` }].map((item, index) => (
              <CarrierSettingLink key={index} link={item.url} label={item.label} />
            ))}
          </Stack>
        </Td>
      </Tr>
    </Fragment>
  );
};

const CarrierSettingLink = ({ link, label }: { link: string; label: string }) => {
  return (
    <Link to={link}>
      <Button colorScheme="teal" variant="ghost">
        {label}
      </Button>
    </Link>
  );
};
